import React from 'react';
import { Box } from '../../../Box';
import { Checkbox } from '../../../Checkbox';
import { Flex } from '../../../Flex';
import { Typography } from '../../../Typography';
import { StickTo } from '../../Table.decl';
import { TableRow } from '../Row/styled';
import { TableHeader } from '../TableHeader/TableHeader';
import { OrderArrow } from './OrderArrow';
import { ActionsHeader } from './styled';

var TableHeaders = function TableHeaders(_ref) {
  var selectable = _ref.selectable,
      hasActions = _ref.hasActions,
      selectColumnDisabled = _ref.selectColumnDisabled,
      selectColumnChecked = _ref.selectColumnChecked,
      columns = _ref.columns,
      order = _ref.order,
      onSelectionChange = _ref.onSelectionChange,
      onOrderChange = _ref.onOrderChange;
  return /*#__PURE__*/React.createElement(Box, {
    as: "thead",
    display: "table-header-group"
  }, /*#__PURE__*/React.createElement(TableRow, null, selectable && /*#__PURE__*/React.createElement(TableHeader, {
    stickTo: StickTo.Left
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !!selectColumnChecked,
    disabled: selectColumnDisabled,
    onChange: onSelectionChange,
    size: "small"
  })), columns.map(function (column, index) {
    var isSortingDisabledExplicitly = column.sortable === false;
    var columnSortable = !!order && !!onOrderChange && !isSortingDisabledExplicitly;
    var arrowVisible = columnSortable && (order == null ? void 0 : order.field) === column.id;
    return /*#__PURE__*/React.createElement(TableHeader, {
      key: index,
      textAlign: column.textAlign
    }, /*#__PURE__*/React.createElement(Flex, {
      onClick: function onClick() {
        return columnSortable && (onOrderChange == null ? void 0 : onOrderChange(column.id));
      },
      cursor: columnSortable ? 'pointer' : 'default'
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      ellipsis: true
    }, column.label), /*#__PURE__*/React.createElement(OrderArrow, {
      visible: arrowVisible,
      orderDirection: order == null ? void 0 : order.direction
    })));
  }), hasActions && /*#__PURE__*/React.createElement(ActionsHeader, {
    stickTo: StickTo.Right
  })));
};

var MemoizedTableHeaders = /*#__PURE__*/React.memo(TableHeaders);
export { MemoizedTableHeaders as TableHeaders };